export default "__VITE_ASSET__1855c181__"